












































import { Component, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";

interface SurveilansCard {
  name: string;
  title: string;
  subtitle: string;
  desc: string;
  icon: string;
  color: string;
  code: string;
}

@Component
export default class SurveilansMenuPage extends Vue {
  readonly items: SurveilansCard[] = [
    {
      name: "ppi-hh-surveilans",
      title: "Surveilans Hand Hygiene",
      subtitle: "WHO 5 Moments — event-based log",
      desc: "Pencatatan kesempatan kebersihan tangan per momen WHO (event-based) untuk pemantauan harian & tren kepatuhan.",
      icon: "mdi-hand-wash",
      color: "blue",
      code: "surveilans_hh"
    },
    {
      name: "ppi-apd-surveilans",
      title: "Surveilans APD",
      subtitle: "INM KPA — PMK 30/2022",
      desc: "Indikator Nasional Mutu Kepatuhan Penggunaan APD (target ≥ 95%). Pelaporan bulanan ke Mutu Fasyankes.",
      icon: "mdi-shield-account",
      color: "indigo",
      code: "surveilans_apd"
    }
  ];

  get visibleItems(): SurveilansCard[] {
    return this.items.filter(i => userModule.hasPrivilege(i.code, "view"));
  }

  goto(name: string) {
    if (this.$route.name !== name) {
      this.$router.push({ name });
    }
  }
}
